import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './RecentOrders.module.css';
import { apiService } from '../../services/api';

const RecentOrders = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    apiService.getOrders({limit: 5})
    .then(data => setOrders(data.orders || []))
    .catch(() => setOrders([]))
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'entregada': return '#10b981';
      case 'enviada': return '#3b82f6';
      case 'en_proceso': return '#f59e0b';
      case 'pendiente': return '#f59e0b';
      case 'cancelada': return '#d32f2f';
      default: return '#6b7280';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'entregada': return 'Entregada';
      case 'enviada': return 'Enviada';
      case 'en_proceso': return 'En proceso';
      case 'pendiente': return 'Pendiente';
      case 'cancelada': return 'Cancelada';
      default: return status;
    }
  };

  return (
    <div className={styles.recentOrders}>
      <div className={styles.header}>
        <h3>Órdenes Recientes</h3>
        <button
          className={styles.viewAll}
          onClick={() => navigate('/admin/orders')}
        >
          Ver todas
        </button>
      </div>
      
      <div className={styles.ordersList}>
        {orders.length === 0 && (
          <div className={styles.noOrders}>No hay órdenes recientes.</div>
        )}
        {orders.map((order) => (
          <div key={order.id} className={styles.orderItem}>
            <div className={styles.orderInfo}>
              <div className={styles.orderId}>{order.user_name}</div>
              <div className={styles.customer}>${order.total?.toFixed(2)}</div>
              <div className={styles.orderDetails}>
                <span>{order.products?.length || 0} items</span>
                <span>•</span>
                <span>{new Date(order.created_at).toLocaleDateString()}</span>
              </div>
            </div>
            <div 
              className={styles.orderStatus}
              style={{ color: getStatusColor(order.status) }}
            >
              {getStatusText(order.status)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentOrders;